/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./LandingPage.css";

import { useHistory, useRouteMatch } from "react-router-dom/cjs/react-router-dom";
import checkBrowserSupport from "../self-assesment/browserDetect.js";
import { useAssessment } from "../self-assesment/AssessmentContext.js";
import { AnalyticsService, BrowserBlockScreen } from "../self-assesment/SelfAssesment.jsx";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd.js";
import { Header } from "./Header.jsx";
import { Footer } from "./Footer.jsx";
import { StartMyra } from "./StartMyra.jsx";
import { LandingPageModal } from "../self-assesment/LandingPage.jsx";

/* ===== LANDING PAGE COMPONENT Ends ===== */

export const LandingPage = () => {
  const [showMemberBlockScreen, setShowMemberBlockScreen] = useState(false);
  const { resetAssessmentData, assessmentData, updateAssessmentData, isMyRAIsActive, setIsMyRAIsActive } = useAssessment();
  const [isMicModalActive, setIsMicModalActive] = useState(false);
  const [micModalMsg, setMicModalMsg] = useState("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
  const [access, setAccess] = useState(true);
  const [showAgeModal, setShowAgeModal] = useState(false);

  const history = useHistory();
  useEffect(() => {
    // removing the previous session ids before creating new one
    const previousSessionIdExits = window.trSessionId || localStorage.getItem("trSessionId");
    if (previousSessionIdExits) {
      localStorage.removeItem("trSessionId");
      window.trSessionId = null;
      console.log("Existing session ID found and removed:", previousSessionIdExits);
    }
    window.screenTracker.enterScreen("landing");
    const initializeSession = async () => {
      const newSessionId = await AnalyticsService.startSession();
    };
    if (window.timeTracker) {
      window.timeTracker.startLandingTimer();
    }
    // We remove the try/catch wrapper because it doesn't help with fetch.
    // Instead, we attach handlers directly to the fetch chain.

    fetch("https://api64.ipify.org?format=json")
      .then((response) => {
        if (!response.ok) throw new Error("IP Service Error");
        return response.json();
      })
      .then((data) => {
        window.backupIP = data.ip;
        // NOT calling initializeSession here  to avoid duplication
      })
      .catch((error) => {
        // This runs if Incognito/AdBlock blocks the request
        console.warn("IP fetch blocked or failed (common in Incognito). Proceeding anyway.", error);
        window.backupIP = null;
      })
      .finally(() => {
        // .finally() runs whether the fetch SUCCEEDED or FAILED.
        // the session is always created.
        initializeSession();
      });
  }, []);

  const onGrant = () => {
    setIsMicModalActive(false);
    if (window._myraPermissionCallbacks?.onGrant) {
      window._myraPermissionCallbacks.onGrant();
    }
  };

  const oncancel = () => {
    window.isStartedLandingFlow = false;
    window.isUserChatWithMyra = false;
    setAccess(false);
    setIsMyRAIsActive(false);
    setMicModalMsg("Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.");
    if (window._myraPermissionCallbacks?.onCancel) {
      window._myraPermissionCallbacks.onCancel();
    }
  };
  const handleHomeButtonCLicked = () => {
    // Cleanup
    resetAssessmentData();
    localStorage.removeItem("assessmentData");
    localStorage.removeItem("dataAfterInfo");
    if (!window.isUserChatWithMyra) {
      console.log("Didn't Started Landing FLow Removing Conditions");
      localStorage.removeItem("userCondition");
    }

    window.screenTracker.exitScreen("landing", {
      exitReason: "started_gsa",
      completed: true,
    });

    // 2. Get the screen flow array (not nested object)
    const finalScreenFlow = window.screenTracker.getScreenFlow();

    // 3. Get timing data
    const timingData = window.timeTracker.startGSATimer();
    let landingDurationSec = null;
    if (finalScreenFlow.length > 0) {
      const landingScreen = finalScreenFlow.find((s) => s.screen === "landing");
      if (landingScreen && landingScreen.enteredAt && landingScreen.exitedAt) {
        const start = new Date(landingScreen.enteredAt);
        const end = new Date(landingScreen.exitedAt);
        landingDurationSec = Math.round((end - start) / 1000);
      }
    }

    // 4. Prepare data - send INDIVIDUAL fields
    const updatedData = {
      ...assessmentData,
      started_assessment: true,
      myraEngagedLanding: window.isUserChatWithMyra ? true : false,
      ...timingData,
      screenFlow: finalScreenFlow,
      gsaStartedAt: timingData,
      timeOnLandingSec: landingDurationSec,
      analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
      session_last_update: new Date().toISOString(),
      EngagedOnLanding: window.isStartedLandingFlow ? true : false,
    };

    // Update and track
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    history.replace("/problem-area");
  };

  /* ===== SVG Icon Components ===== */
  const MicIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="8" y1="23" x2="16" y2="23" />
    </svg>
  );

  const ChatIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );

  const BuildingIcon = () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  );

  const PeopleIcon = () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );

  const HeartIcon = () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
    </svg>
  );

  /* ===== Chip data for scrolling carousel ===== */
  const chipTexts = ['"How does autonomous recovery work?"', '"What does this cost per employee?"', '"How is this different from other digital PT?"', '"What does implementation look like?"', '"Is this considered medical care?"', '"How are privacy and HIPAA handled?"', '"What happens during the assessment?"', '"What happens after the first free week?"'];

  /* ===== Care steps data ===== */
  const careSteps = [
    {
      num: 1,
      title: "Guided Self-Assessment",
      desc: "Myra walks you through a simple assessment: a few focused questions and guided movement checks. In about 10 minutes, she understands your goals, your pain, and how you move.",
    },
    {
      num: 2,
      title: "Personalizes Your Recovery Plan",
      desc: "Based on your assessment, Myra builds a plan tailored to your pain level, mobility, and starting ability. She explains what's included, why each exercise matters, and answers any questions before you begin.",
    },
    {
      num: 3,
      title: "Guides Your Recovery Sessions",
      desc: "Myra coaches each exercise with clear voice guidance and on-screen feedback. If something feels unclear or too challenging, you can ask and she responds in the moment.",
    },
    {
      num: 4,
      title: "Adjusts When You Need It",
      desc: "As your pain decreases and mobility improves, Myra updates your plan. If a session feels too hard, too easy, or uncomfortable, she listens to your feedback and adjusts, session by session.",
    },
    {
      num: 5,
      title: "Always Available",
      desc: "Have a question about your plan? Unsure why something is included? Need help between sessions? Myra is there whenever you need her.",
    },
  ];

  /* ===== Results data ===== */
  const results = [
    { number: "75%", label: "Avg. Pain Reduction", desc: "Participants report meaningful improvement during structured recovery programs." },
    { number: "29.6", label: "Day Recovery Window", desc: "Adaptive protocols drive measurable improvement in weeks, not months." },
    { number: "2×", label: "Higher Adherence", desc: "Short sessions and real-time voice guidance keep people consistent." },
    { number: "$68", label: "Per 8-Week Episode", desc: "A fraction of legacy digital MSK programs. No hardware. No app." },
  ];

  /* ===== Pricing data ===== */
  const pricingCards = [
    {
      label: "Episodic",
      title: "Episodic Recovery Model",
      sub: "Complete 8-week recovery. Unlimited sessions.",
      items: ["Free Guided Self-Assessment and first week of recovery, no charge, no commitment", "$68 for the remaining 7 weeks of guided recovery", "$10 completion incentive for employees", "Unlimited sessions throughout the recovery episode", "No app download or hardware required"],
    },
    {
      label: "Population",
      title: "Population-Based Model",
      sub: "Enterprise-level access across your workforce. PEPM / PMPM.",
      items: ["Predictable monthly pricing structure", "Universal access to Guided Self-Assessment", "No per-episode billing complexity", "Tiered pricing based on population size"],
    },
  ];

  /* ===== Who We Work With data ===== */
  const audiences = [
    {
      icon: <BuildingIcon />,
      title: "Employers",
      desc: "Your employees can talk to Myra from any browser, on any device, whenever pain is getting in the way. She guides them through assessment, builds a personalized plan, coaches every session, and adapts as they improve. No scheduling. No waiting. Recovery that meets them where they are.",
    },
    {
      icon: <PeopleIcon />,
      title: "Partners & Brokers",
      desc: "Add Myra's recovery coaching to your benefits portfolio without adding operational complexity. White-label and co-branded options, flexible pricing models, and outcome reporting that demonstrates value to your clients.",
    },
    {
      icon: <HeartIcon />,
      title: "Health Systems & Providers",
      desc: "Offer guided MSK recovery anytime, from any browser. Myra manages assessment, plan generation, and session delivery within defined clinical guardrails. Expand access and reduce backlog without extending clinician hours.",
    },
  ];
  if (showMemberBlockScreen) {
    return <BrowserBlockScreen featureType="member" />;
  }
  return (
    <div className="landing-page">
      <Header setShowMemberBlockScreen={setShowMemberBlockScreen} onTryMyraClick={() => StartMyra(setIsMicModalActive, setIsMyRAIsActive)} />
      {isMicModalActive && <LandingPageModal message={micModalMsg} onGrant={onGrant} onCancel={oncancel} isMicModalActive={isMicModalActive} setIsMicModalActive={setIsMicModalActive} access={access} setAccess={setAccess} setMicModalMsg={setMicModalMsg} />}
      {/* HERO */}
      <section className="hero-section">
        <div className="hero-inner">
          <h1>
            Personalized Recovery for Every Employee <span className="accent">in Pain.</span>
          </h1>
          <div className="hero-narrative">
            <p className="hero-pain">Most employees with muscle and joint pain never get care. They wait. They push through it. Or they give up.</p>
            <p className="hero-pain-lines">
              <strong>Pain lingers. Productivity drops. Claims rise.</strong>
            </p>
            <p className="hero-solution">Virdio Health reaches them with Myra, an AI-powered recovery coach that guides assessment, builds a personalized plan, and adapts in real time.</p>
            <p className="hero-access">
              On their own device.
              <br />
              On their own schedule.
              <br />
              From any browser.
            </p>
          </div>
          <div className="hero-cta-area">
            <button onClick={() => StartMyra(setIsMicModalActive, setIsMyRAIsActive)} className="btn-primary" rel="noopener noreferrer">
              <MicIcon />
              Ask Myra Anything
            </button>
            <p className="hero-cta-sub">Experience Myra just as your employees would. No signup required.</p>
            <p className="hero-specialist">
              Prefer a conversation? <Link to="/contact-us">Speak with a specialist.</Link>
            </p>
          </div>
        </div>
      </section>

      {/* MEET MYRA */}
      <section className="myra-module">
        <div className="myra-module-inner">
          <p className="myra-module-label">Meet Myra</p>
          <h2>Your Muscle &amp; Joint Recovery Coach, Powered by AI</h2>
          <p className="myra-module-sub">Myra is live. Ask her how recovery works or let her guide you through an assessment.</p>
          <div className="myra-chat-preview">
            <div className="myra-avatar">
              <ChatIcon />
            </div>
            <div className="myra-bubble">
              <strong>Hi, I'm Myra.</strong> How can I help?
            </div>
          </div>
          <button onClick={() => StartMyra(setIsMicModalActive, setIsMyRAIsActive)} className="myra-mic-btn" rel="noopener noreferrer">
            <MicIcon />
            Ask Myra Anything
          </button>
          <p className="myra-nosignup">No signup required.</p>
          <div className="chips-wrapper">
            <div className="chips-track">
              {/* Duplicate chips for seamless loop */}
              {[...chipTexts, ...chipTexts].map((text, i) => (
                <span className="chip" key={i}>
                  {text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* THE NEW MODEL */}
      <section className="care-section">
        <div className="section-container">
          <div className="section-header">
            <p className="section-label">The New Model for MSK Recovery</p>
            <h2 className="section-title">Myra Is the Recovery Guide.</h2>
            <p className="section-desc">Myra operates within structured, evidence-based guardrails and delivers the recovery experience directly.</p>
          </div>
          <div className="care-grid">
            {careSteps.map((step) => (
              <div className="care-step" key={step.num}>
                <div className="care-step-num">{step.num}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
          <div className="care-closing">
            <p className="care-closing-lead">Our approach reshapes the recovery journey.</p>
            <p className="care-closing-points">Access expands. Friction decreases. Costs are fundamentally reduced.</p>
          </div>
        </div>
      </section>

      {/* REINVENTING */}
      <section className="reinvent-section">
        <div className="section-container">
          <div className="reinvent-inner">
            <div className="section-header">
              <p className="section-label">The Vision</p>
              <h2 className="section-title">Reinventing Digital MSK Recovery</h2>
            </div>
            <div className="reinvent-block">
              <p className="reinvent-lead">Digital MSK expanded access to care.</p>
              <p className="reinvent-lines">
                The first wave largely digitized the traditional care model.
                <br />
                Clinicians remained at the center.
                <br />
                Workflows remained enrollment-based.
                <br />
                Pricing remained tied to per-episode delivery.
              </p>
            </div>
            <div className="reinvent-divider"></div>
            <div className="reinvent-block">
              <p className="reinvent-vision-lead">Virdio Health started from a different place.</p>
              <p className="reinvent-questions">
                What if anyone could come to a website and better understand their pain?
                <br />
                What if intelligence could map a personalized path forward?
                <br />
                What if the path forward could adjust in real time?
              </p>
            </div>
            <p className="reinvent-close">That difference isn't incremental. It begins at the foundation.</p>
          </div>
        </div>
      </section>

      {/* RESULTS */}
      <section className="results-section">
        <div className="section-container">
          <div className="section-header">
            <p className="section-label">Results</p>
            <h2 className="section-title">Built on Evidence. Backed by Outcomes.</h2>
          </div>
          <div className="results-grid">
            {results.map((r, i) => (
              <div className="result-card" key={i}>
                <div className="result-number">{r.number}</div>
                <div className="result-label">{r.label}</div>
                <div className="result-desc">{r.desc}</div>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <a href="/clinical-pilot-summary.pdf" target="_blank" rel="noopener noreferrer" className="btn-outline">
              View Clinical Summary →
            </a>
            <p className="section-cta-sub">See the data behind the results.</p>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="pricing-section">
        <div className="section-container">
          <div className="section-header section-header--center">
            <p className="section-label">Pricing</p>
            <h2 className="section-title">Two Flexible Approaches</h2>
          </div>
          <div className="pricing-grid">
            {pricingCards.map((card, i) => (
              <div className="pricing-card" key={i}>
                <p className="pricing-card-label">{card.label}</p>
                <h3>{card.title}</h3>
                <p className="pricing-card-sub">{card.sub}</p>
                <ul className="pricing-list">
                  {card.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Link to="/contact-us" className="btn-primary">
              Talk to Us About Pricing
            </Link>
          </div>
        </div>
      </section>

      {/* WHO WE WORK WITH */}
      <section className="workwith-section">
        <div className="section-container">
          <div className="section-header">
            <p className="section-label">Who We Work With</p>
            <h2 className="section-title">Designed for Decision-Makers. Built for People.</h2>
          </div>
          <div className="workwith-grid">
            {audiences.map((a, i) => (
              <div className="workwith-card" key={i}>
                <div className="workwith-icon">{a.icon}</div>
                <h3>{a.title}</h3>
                <p>{a.desc}</p>
              </div>
            ))}
          </div>
          <div className="section-cta">
            <Link to="/contact-us" className="btn-primary">
              Let's Talk About Your Organization
            </Link>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="final-cta">
        <div className="final-cta-inner">
          <h2>Experience Myra. Right Now.</h2>
          <p className="final-cta-sub">Take a free Guided Self-Assessment on your own device. The same experience your employees would have.</p>
          <div className="final-cta-buttons">
            <button onClick={() => setShowAgeModal(true)} className="btn-primary" rel="noopener noreferrer">
              Start Your Free Guided Self-Assessment
            </button>
          </div>
          <p className="final-cta-specialist">
            Prefer a conversation? <Link to="/contact-us">Speak with a specialist.</Link>
          </p>
        </div>
      </section>
      {showAgeModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Confirmation Required</h3>
            <p>I confirm that I'm 18 years of age or older.</p>

            <div className="modal-buttons">
              <button
                className="btn-confirm"
                onClick={() => {
                  setShowAgeModal(false);
                  handleHomeButtonCLicked();
                }}
              >
                Confirm
              </button>

              <button className="btn-cancel" onClick={() => setShowAgeModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};
